import { ClientType } from 'app/client/main/models/ClientType';
import { TransferReservationPrivateModel } from '../../private/models/TransferReservatinPrivateModel';
import { TransferReservationModel } from '../models/TransferReservation';

export const isTransferReservationPrivate = (
  x: TransferReservationModel | TransferReservationPrivateModel
): x is TransferReservationPrivateModel => {
  return x.clientType === ClientType.private;
};
